<template>
  <div :class="classes">
      <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber"
      :page-size="pageSize" ref="table" isAddPageToRouter :isOutside="isOutside">
          <wt-table :list="tableData" :labels="tableLabels" v-loading="loading">
            <template slot="before">
                <el-table-column label="商品名称" min-width="300" header-align="center" :fit="false" fixed="left">
                    <template slot-scope="scope">
                        <div :class="$style['goods-price-name']">
                            <div :class="$style['banner-picture-div']">
                            <pt-img :class="$style['banner-picture']"
                            :src="scope.row.goodsDTO.goodsData.mainPicture" styleName="mall-goods-banner-pictures"></pt-img>
                            </div>
                            <div :class="$style['goods-name-price']">
                                <div> {{scope.row.goodsDTO.goodsData.name}}</div>
                                <!-- <div>{{scope.row.final_price}}</div> -->
                                <!-- <template  v-if="scope.row.abstractPromotionEvents">
                                    <div  v-for="(item,index) in scope.row.abstractPromotionEvents" :key="index" class="promotion-content" :style="{color:item.promotionStatusColor}">
                                        <div>
                                        {{getPromotionTitle(item)}}
                                        </div>
                                        <div>
                                            开始：{{item.promotionStartTime}}
                                        </div>
                                        <div>
                                            结束：{{item.promotionEndTime}}
                                        </div>
                                    </div>
                                </template> -->
                                <div v-if="scope.row.promotionData" class="promotion-content" :style="{color:scope.row.promotionStatusColor}">
                                    <div>
                                    {{getPromotionTitle(scope.row)}}
                                    </div>
                                    <div>
                                        开始：{{scope.row.promotionStartTime}}
                                    </div>
                                    <div>
                                        结束：{{scope.row.promotionEndTime}}
                                    </div>
                                    <div v-if="scope.row.promotionData.promotionType==='CASH_BACK'">(奖励内容请见详情)</div>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="价格" min-width="180">
                    <template slot-scope="scope">
                        <template v-if="scope.row.promotionEvent&&scope.row.promotionEvent.status=='ACTIVATED'">
                          <div v-for="(item,index) in fullPayPrice(scope.row,true)" :key='index'>
                            <div :style="{textDecoration: (isInPromotion(scope.row.promotionEvent.promotionData)&&(item.active_text||item.active_price)) ? 'line-through' : 'none'}" >
                                <span :class="$style.price_show_text">{{item.text}}</span>
                                <span>{{item.price}}</span>
                            </div>
                            <div :style="{color:scope.row.promotionStatusColor}" v-if="item.active_text||item.active_price">
                                <span :class="$style.price_show_text">{{item.active_text}}</span>
                                <span>{{item.active_price}}</span>
                            </div>
                            <!-- <div v-else :style="{color:scope.row.promotionStatusColor}">
                                ¥{{scope.row.promotionPrice}}
                            </div> -->
                          </div>
                        </template>
                        <div v-else>
                          <div v-for="(item,index) in fullPayPrice(scope.row)" :key="index">
                            <span :class="$style.price_show_text">{{item.text}}</span>
                            <span>{{item.price}}</span>
                          </div>
                        </div>
                    </template>
                </el-table-column>
            </template>
            <template>
                 <slot/>
            </template>
          </wt-table>
      </wt-paged-table>
  </div>
</template>

<script>
import { getPromotionType } from 'enumeration/mall.js'
import { getCurrentTimestamp } from 'utils/formUtils'
// 组件class前缀
const prefixCls = 'pt-goods-manage-table'

export default {
  name: 'pt-goods-manage-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    getGoodsList: {
      type: Function
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    isOutside: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pageLayout: 'total, prev, pager, next,jumper',
      table_data: this.tableData,
      routerName: ''
    }
  },
  watch: {
    tableData: {
      handler: function (val) {
        this.table_data = val
      },
      deep: true
    }
  },
  methods: {
    // 价格显示(全款)
    fullPayPrice (row, isActive) {
      let res = []
      let activePrice = (row.promotionMinPrice && row.promotionMaxPrice) ? ('¥' + row.promotionMinPrice + '-¥' + row.promotionMaxPrice) : ('¥' + row.promotionPrice)
      let activeBalance = (row.promotionMinBalance && row.promotionMaxBalance) ? ('¥' + row.promotionMinBalance + '-¥' + row.promotionMaxBalance) : ('¥' + row.promotionBalance)
      let depostAndBalance = [
        {
          // active_text: '订金',
          text: '订金',
          price: row.final_deposit
        },
        {
          active_text: '尾款',
          text: '尾款',
          price: row.final_balance,
          active_price: activeBalance
        }
      ]
      let fullObj = {
        active_text: '全款',
        text: '全款',
        price: row.final_price,
        active_price: activePrice
      }
      if (!row.paymentModes || !row.paymentModes.length) {
        res.push({
          active_price: activePrice,
          price: row.final_price
        })
      } else if (row.paymentModes.length === 1) {
        if (row.paymentModes.indexOf('LUMP_SUM') > -1) {
          res.push({
            active_price: activePrice,
            price: row.final_price
          })
        } else if (row.paymentModes.indexOf('DEPOSIT_AND_BALANCE') > -1) {
          res = res.concat(depostAndBalance)
        }
      } else {
        res = res.concat(depostAndBalance)
        res.push(fullObj)
      }

      return res
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    getPromotionTitle (row) {
      if (row.promotionData) {
        let promotion = row.promotionData
        return getPromotionType(promotion.promotionType) + ' ' + this.formatPromotionProgress(promotion)
      }
    },
    formatPromotionProgress (promotionData) {
      return this.isInPromotion(promotionData) ? '进行中' : '待开始'
    },
    isInPromotion (promotionData) {
      let now = getCurrentTimestamp()
      return now > promotionData.startTime
    },
    getTableData (page, next) {
      this.$emit('get-goods-list', page, next)
    },
    showReTry () {
      this.$refs.table.showReTry()
    }
  },

  created () {
    this.routerName = this.$route.name
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.goods-price-name{
    display: flex;
    line-height: inherit;
    width: 100%;
    padding: 10px;
}
.price_show_text{
  margin-right: 10px
}
:global
.pt-goods-manage-table{
.el-button{
    margin-right: 10px;
    +.el-button{
        margin-left: 0
    }
}
}
.goods-name-price{
    // display: flex;
    padding-left: 20px;
    flex-direction: column;
    display: -webkit-inline-box;
    white-space:initial;
    justify-content: space-between;
    :global
    div{
        word-break:break-word
    }
}
.banner-picture-div{
    display: flex;
    justify-content: center;
    align-items: center;
}
.banner-picture{
    :global
        img{
            max-width: 100px;
            border-radius: 10px;
        }
}
.promotion-content{
    :global
    div{
    font-size: 13px
    }
}
</style>
